import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { LocaleProvider } from './i18n/LocaleContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { DataProvider } from './data/DataContext';

import AppLayout from './components/layout/AppLayout';
import RequireAuth, { RedirectIfAuthenticated } from './components/layout/RequireAuth';
import RequirePermission from './components/layout/RequirePermission';
import ToastViewport from './components/ui/ToastViewport';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MembersPage from './pages/MembersPage';
import EventsPage from './pages/EventsPage';
import PaymentsPage from './pages/PaymentsPage';
import ReportsPage from './pages/ReportsPage';
import UsersPage from './pages/UsersPage';
import RolesPage from './pages/RolesPage';
import AuditPage from './pages/AuditPage';
import ReservationsPage from './pages/ReservationsPage';
import PayoutsPage from './pages/PayoutsPage';
import FinancePage from './pages/FinancePage';
import SettingsPage from './pages/SettingsPage';
import TransportPage from './pages/TransportPage';
import DocumentsPage from './pages/DocumentsPage';
import ProfilePage from './pages/ProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <LocaleProvider>
      <ToastProvider>
        <AuthProvider>
          <DataProvider>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/login"
                  element={(
                    <RedirectIfAuthenticated>
                      <LoginPage />
                    </RedirectIfAuthenticated>
                  )}
                />
                <Route
                  element={(
                    <RequireAuth>
                      <AppLayout />
                    </RequireAuth>
                  )}
                >
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/forbidden" element={<ForbiddenPage />} />

                  <Route path="/members" element={
                    <RequirePermission permission="members:view"><MembersPage /></RequirePermission>
                  } />
                  <Route path="/events" element={
                    <RequirePermission permission="events:view"><EventsPage /></RequirePermission>
                  } />
                  <Route path="/payments" element={
                    <RequirePermission permission="payments:view"><PaymentsPage /></RequirePermission>
                  } />
                  <Route path="/reservations" element={
                    <RequirePermission permission="reservations:view"><ReservationsPage /></RequirePermission>
                  } />
                  <Route path="/transport" element={
                    <RequirePermission permission="transport:view"><TransportPage /></RequirePermission>
                  } />
                  <Route path="/finance" element={
                    <RequirePermission permission="payments:view"><FinancePage /></RequirePermission>
                  } />
                  <Route path="/payouts" element={
                    <RequirePermission permission="payouts:view"><PayoutsPage /></RequirePermission>
                  } />
                  <Route path="/documents" element={
                    <RequirePermission permission="documents:view"><DocumentsPage /></RequirePermission>
                  } />
                  <Route path="/reports" element={
                    <RequirePermission permission="reports:view"><ReportsPage /></RequirePermission>
                  } />
                  <Route path="/users" element={
                    <RequirePermission permission="users:view"><UsersPage /></RequirePermission>
                  } />
                  <Route path="/roles" element={
                    <RequirePermission permission="roles:view"><RolesPage /></RequirePermission>
                  } />
                  <Route path="/audit" element={
                    <RequirePermission permission="audit:view"><AuditPage /></RequirePermission>
                  } />
                  <Route path="/settings" element={
                    <RequirePermission permission="settings:manage" role="admin"><SettingsPage /></RequirePermission>
                  } />

                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <ToastViewport />
          </DataProvider>
        </AuthProvider>
      </ToastProvider>
    </LocaleProvider>
  );
}
